module.exports = __webpack_public_path__ + "img/pro_one_6.b205b502.jpg";